import { Outlet, useLocation } from "react-router-dom";
import CoreNavbar from "./helpers/core-navbar";
import { useEffect } from "react";
import { TagManager } from "@dealer-center/core-third-party-gtm";
import { Box } from "@dealer-center/core-components";
import BridgeBar from "./helpers/BridgeBar";
export function Layout() {
  const location = useLocation();

  useEffect(() => {
    TagManager.event({
      eventName: "page_view"
    });
  }, [location]);
  return (
    <>
      <BridgeBar data-testid="ddc-bridge-bar" />
      <CoreNavbar data-testid="ddc-nav-bar">
        <Box data-testid="ddc-page">
          <Outlet />
        </Box>
      </CoreNavbar>
    </>
  );
}
